import { lazy } from "react";
import ROUTE_PATHS from "constant/routePaths";
import { LAYOUTS } from "constant";
import {
  getActionPermission,
  isHistoryAllowed,
  isImportAllowed,
  isOrderCreationAllowed,
  isTrackAllowed,
} from "helpers/permission.helper";
import { Actions, BulkOrderCreate, OutboundTrack, SingleOrderCreate } from "./permissionPaths";
import NoPermissionComponent from "components/ui/NoPermissionComponent";
import { hasFeatureFlag, MULTIPLE_ORDERS_MAP_VIEW } from "featureFlags";

const Home = lazy(() => import("components/pages/Home"));
const Login = lazy(() => import("components/pages/Login"));
const OrderDetails = lazy(() => import("components/ui/OrderDetails"));
const TrackPage = lazy(() => import("components/pages/Track"));
const TrackPageV2 = lazy(() => import("components/pages/TrackV2/index"));
const TrackNonLogin = lazy(() => import("components/pages/TrackNonLogin"));
const BulkOrderListing = lazy(() => import("components/pages/OrderListing/BulkOrderListing"));
const CreateOrder = lazy(() => import("components/pages/AddOrder/order"));
const BulkOrderVerify = lazy(() => import("components/pages/AddOrder/BulkOrdersVerify"));
const HistoryPage = lazy(() => import("components/pages/History"));
const UserInfo = lazy(() => import("components/pages/UserInfo"));

const hasMultipleOrdersMapView = hasFeatureFlag(MULTIPLE_ORDERS_MAP_VIEW);

const publicRoutes = [
  {
    path: ROUTE_PATHS.LANDING_PAGE,
    name: "Landing page",
    exact: true,
    component: Home,
    layout: LAYOUTS.AUTH,
    restricted: true,
  },
  {
    path: ROUTE_PATHS.LOGIN,
    name: "Login",
    exact: false,
    component: Login,
    layout: LAYOUTS.AUTH,
    restricted: true,
  },
  {
    path: ROUTE_PATHS.TRACK_NON_LOGIN,
    name: "Track non login",
    exact: false,
    component: TrackNonLogin,
    layout: LAYOUTS.DEFAULT,
    restricted: true,
  },
  {
    path: `${ROUTE_PATHS.ORDER_DETAILS}/:orderId`,
    name: "Order details",
    exact: true,
    component: OrderDetails,
    layout: LAYOUTS.DEFAULT,
    restricted: false,
  },
  {
    path: ROUTE_PATHS.NO_PERMISSION,
    name: "No Permission",
    exact: true,
    component: NoPermissionComponent,
    layout: LAYOUTS.DEFAULT,
    restricted: false,
  }
];

const privateRoutes = [
  {
    path: ROUTE_PATHS.TRACK,
    name: "Track",
    exact: false,
    // component: TrackPage,
    component: hasMultipleOrdersMapView ? TrackPageV2 : TrackPage,
    layout: LAYOUTS.DEFAULT,
    loading: false,
    isAccess: false,
    validatePermission: (userPermissions: []) => isTrackAllowed(userPermissions),
  },
  {
    path: ROUTE_PATHS.CREATE_ORDER,
    name: "Create order",
    exact: true,
    component: CreateOrder,
    layout: LAYOUTS.DEFAULT,
    loading: false,
    isAccess: false,
    validatePermission: (userPermissions: []) => isOrderCreationAllowed(userPermissions),
  },
  {
    path: `${ROUTE_PATHS.EDIT_ORDER}/:orderId`,
    name: "Edit order",
    exact: false,
    component: CreateOrder,
    layout: LAYOUTS.COMPACT,
    loading: false,
    isAccess: false,
    validatePermission: (userPermissions: []) => { return getActionPermission(userPermissions, OutboundTrack, Actions.edit)},
  },
  {
    path: ROUTE_PATHS.CREATE_SINGLE_ORDER,
    name: "Create single order",
    exact: false,
    component: CreateOrder,
    layout: LAYOUTS.COMPACT,
    loading: false,
    isAccess: false,
    validatePermission: (userPermissions: []) => {
       return getActionPermission(userPermissions, SingleOrderCreate, Actions.create);
    },
  },
  {
    path: ROUTE_PATHS.BULK_ORDER,
    name: "Bulk order",
    exact: false,
    component: BulkOrderVerify,
    layout: LAYOUTS.COMPACT,
    loading: true,
    isAccess: true,
    validatePermission: (userPermissions: []) => {
      return getActionPermission(userPermissions, BulkOrderCreate, Actions.create);
    },
  },
  {
    path: ROUTE_PATHS.HISTORY,
    name: "History",
    exact: false,
    component: HistoryPage,
    layout: LAYOUTS.DEFAULT,
    loading: false,
    isAccess: false,
    validatePermission: (userPermissions: []) => isHistoryAllowed(userPermissions),
  },
  {
    path: ROUTE_PATHS.IMPORT_LIST,
    name: "Bulk order listing",
    exact: false,
    component: BulkOrderListing,
    layout: LAYOUTS.DEFAULT,
    loading: true,
    isAccess: true,
    validatePermission: (userPermissions: []) => isImportAllowed(userPermissions),
  },
  {
    path: ROUTE_PATHS.PROFILE,
    name: "Profile",
    exact: false,
    component: UserInfo,
    layout: LAYOUTS.COMPACT,
    loading: false,
    isAccess: false,
    validatePermission: () => {
      return true;
    },
  },
];

export { publicRoutes, privateRoutes };
